import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { usePricing } from "../context/PricingContext";
import { useI18n } from "../i18n";

const API = "/api";

/**
 * RC-WEB-3 §6/§7 — availability + copy for payment rails, straight from the master
 * admin configuration. The UI never decides which rails exist and never hardcodes a
 * confirmation window: both come from the backend contract.
 */
export function usePaymentMethods(countryOverride) {
  const { country } = usePricing();
  const { lang } = useI18n();
  const [methods, setMethods] = useState(null);
  const effectiveCountry = countryOverride || country;

  useEffect(() => {
    if (!effectiveCountry) return;
    const controller = new AbortController();
    const iso = effectiveCountry === "XX" ? "" : effectiveCountry;
    axios
      .get(`${API}/payment-methods?country_code=${iso}&locale=${lang || "es"}`, {
        signal: controller.signal,
      })
      .then((r) => setMethods(r.data?.methods || []))
      .catch(() => setMethods([]));
    return () => controller.abort();
  }, [effectiveCountry, lang]);

  const isActive = useCallback(
    (key) => !!methods?.some((m) => m.key === key),
    [methods],
  );
  const methodCopy = useCallback(
    (key) => methods?.find((m) => m.key === key) || null,
    [methods],
  );

  return { methods, loadingMethods: methods === null, isActive, methodCopy };
}

export default usePaymentMethods;
